import React,{useState} from 'react';
import { Component } from 'react';
import { Modal, Button } from "mdbreact";
// import {HOSTNAME} from './environment';
const login_link="https://bhuvan-cas1.nrsc.gov.in/cas/login?service=http://bhuvan-staging1.nrsc.gov.in:3012/"
export default class NHPCASLogin extends Component  {    
    // const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    render()
    {
      console.log(login_link)
        const url=new URL(login_link)
        if (url.hostname === 'bhuvan-staging1.nrsc.gov.in' ) return <a target="_blank" href={login_link}>{login_link}</a>
        else return(
       <div>
      <iframe src={login_link} style={{width:'100%',height:'400px'}}/>
      
    </div>)
       
    }
    
  }